module.exports = __webpack_public_path__ + "img/028-equality.254835ec.svg";